import type { MouseEvent } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import LinkButton from '_components/UI/LinkButton';

import type { BrandTileImage } from '../types';

import styles from './BrandCard.module.scss';

export interface BrandCardProps {
  href: string;
  name: string;
  logo: BrandTileImage | null;
  image: BrandTileImage | null;
  ctaLabel: string | null;
  priority?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const BrandCard = ({
  href,
  name,
  logo,
  image,
  ctaLabel,
  priority = false,
  onClick,
}: BrandCardProps) => {
  const { t } = useTranslation('common');

  return (
    <a href={href} className={styles.card} onClick={onClick}>
      {image && (
        <span className={styles.imageWrapper}>
          <Image
            src={image.url}
            alt={logo ? '' : name}
            fill
            sizes="(min-width: 988px) 342px, 179px"
            priority={priority}
            className={styles.image}
          />
        </span>
      )}
      <span
        className={cn(styles.overlay, { [styles.overlayNoLogo]: !logo })}
        aria-hidden="true"
      />
      {logo && (
        <span className={styles.logo}>
          <Image
            src={logo.url}
            alt={name}
            fill
            sizes="(min-width: 988px) 242px, 131px"
            priority={priority && !image}
            className={styles.logoImage}
          />
        </span>
      )}
      <span className={styles.ctaWrapper} aria-hidden="true">
        <LinkButton as="span" variant="white">
          {ctaLabel || t('brandTiles.shopNow')}
        </LinkButton>
      </span>
    </a>
  );
};

export default BrandCard;
